import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { MaintenanceService } from './maintenance.service';

export const maintenanceCanMatchGuard: CanMatchFn = (route): boolean | UrlTree => {
  const maintenanceService = inject(MaintenanceService);
  const router = inject(Router);

  const productType = route.data?.['product'] as string | undefined;

  if (productType && maintenanceService.isProductInMaintenance(productType)) {
    return router.parseUrl('/maintenance/feature');
  }

  return true;
};

export const maintenanceRedirectGuard: CanMatchFn = (route): boolean | UrlTree => {
  const maintenanceService = inject(MaintenanceService);
  const router = inject(Router);

  const routePath = route.path;

  if (maintenanceService.isAppInMaintenance() && routePath !== 'maintenance') {
    return router.parseUrl('/maintenance');
  }

  return true;
};
